import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-input-models',
  templateUrl: './input-models.component.html',
  styleUrls: []
})
export class InputModelsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

